import { RootState } from 'store/root-reducer';

export const getOverload = (state: RootState) => state.statistics.overload;
